import React from 'react'
import { Use_reduce_state } from './Store'
import './Cart.css'
import { Price_Formation } from './Price_Formation';

function Cart() {
    const {product:{cart}, dis} = Use_reduce_state();
    const SubTotal = (a,b) =>{
        return a*b;
    }
    let {totalItem, totalPrice} = cart.reduce((acc, curr) =>{
        acc.totalItem += curr.qty;
        acc.totalPrice += curr.price*curr.qty;
        return acc;
    } ,{
        totalItem:0,
        totalPrice:0
    })
    return (
    <div className='container'>
    <div className='row'>
        { cart.length > 0 ? (
            <>
            <div className="col-md-8">
            <div className="col-md-8">
                <table class="table table-light">
                    <thead>
                        <tr>
                        <th scope="col">Product</th>
                        <th scope="col">Name</th>
                        <th scope="col">Qty</th>
                        <th scope="col">Price</th>
                        <th scope="col">Subtotal</th>
                        <th scope='col'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            cart.map((i)=>{
                                return(
                                    <tr>
                                    <td><img src={i.thumbnail} className='img_cart' /> </td>
                                    <td>{i.title}</td>
                                    <td>{i.qty}</td>
                                    <td>{Price_Formation(i.price)}</td>
                                    <td>{Price_Formation(SubTotal(i.price,i.qty))}</td>
                                    <td>
                                        <button type='button' className='close ' aria-label='Close' onClick={()=>
                                        dis({
                                            type: "REMOVE_FROM_CART",
                                            payload:i
                                        })}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </td>
                                    </tr>
                                )
                            })
                        }
                        
                    </tbody>
                </table>
        </div>
        </div>
        <div className="col-md-4">
        <table class="table table-light">
            <thead>
                <tr>
                <th scope="col">Total item in your cart</th>
                <th scope="col">Total Price</th>
                </tr>
            </thead>
            <tbody>
            <tr>
                <th scope="row ">{totalItem}</th>
                <td>{Price_Formation(totalPrice)}</td>
            </tr>
            </tbody>
        </table>
        </div>
        </>
        ) : (<h1 className='text-center'> Your Cart Is Empty</h1>)}
        
    </div>
    </div>
  )
}

export default Cart